import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'

import { GET, PUT } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const [poses, setPoses] = useState([])
	const [selectedPos, setSelectedPos] = useState(null)
	const [meta, setMeta] = useState([])
	const [settings, setSettings] = useState([])
	const [saving, setSaving] = useState(false)

	async function loadPoses() {
		const response = await GET('/services/web/api/pos-helper')
		if (response) setPoses(response)
	}

	async function loadMeta() {
		const response = await GET('/services/web/api/sms-categories/meta')
		if (response) setMeta(response)
	}

	async function loadForPos(posId) {
		const response = await GET(`/services/web/api/pos/${posId}/sms-categories`)
		if (response) setSettings(response)
	}

	async function save() {
		if (!selectedPos) return
		setSaving(true)
		await PUT(`/services/web/api/pos/${selectedPos.id}/sms-categories`, settings, { loader: true })
		setSaving(false)
	}

	function toggle(category, enabled) {
		setSettings(prev => prev.map(s => s.category === category ? { ...s, enabled } : s))
	}

	useEffect(() => {
		loadPoses()
		loadMeta()
	}, [])

	useEffect(() => {
		if (selectedPos) loadForPos(selectedPos.id)
	}, [selectedPos])

	return (
		<>
			<div className="page-header d-flex mb-2">
				<h4 className="vertical-center">
					{t('SMS_SETTINGS')}
				</h4>
			</div>

			<div className="card mb-3">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-4">
						<div className="vertical-center">
							<h6 className="m-0 fw-600">{t('POS')}</h6>
						</div>
						<div className="vertical-center w-250px">
							<Select
								options={poses}
								value={selectedPos}
								onChange={setSelectedPos}
								placeholder=""
								noOptionsMessage={() => t('LIST_IS_EMPTY')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
					</div>

					{selectedPos && meta.length > 0 && (
						<>
							<h5 className="settings_title">{t('SMS_CATEGORIES')}</h5>
							<p className="fz14 text-muted">{t('SMS_CATEGORIES_HINT')}</p>

							{meta.map(m => {
								const current = settings.find(s => s.category === m.category)
								const enabled = current ? current.enabled : true
								return (
									<div key={m.category} className="d-flex justify-content-between mb-2">
										<p className="fw-600 vertical-center m-0">{t(m.labelKey)}</p>
										<div className="form-check form-switch form-switch-lg">
											<input
												type="checkbox"
												className="form-check-input"
												checked={enabled}
												onChange={(e) => toggle(m.category, e.target.checked)}
											/>
										</div>
									</div>
								)
							})}

							<div className="d-flex justify-content-end mt-4">
								<button className="btn btn-primary btn-rounded btn-wide" onClick={save} disabled={saving}>
									{t('SAVE')}
								</button>
							</div>
						</>
					)}
				</div>
			</div>
		</>
	)
}

export default Index
